import { useEffect } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { useAdminUserContext } from '@nv/contexts'
import { useQuery } from '@nv/hooks'
import { AdminVoterAuthService } from '@nv/services'
import { AdminVoterService } from '@nv/services'
import { beforeUnload, nxConfig } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export const useAdminKeycloakAuth = () => {
  const { setAdminUser, setTiviLink, initialized, setInitialized, setAuthChecked } = useAdminUserContext()
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const pathname = window.location.pathname

  useEffect(() => {
    const initializeSSO = async () => {
      if (!initialized) {
        KeycloakAdminService.initKeycloak(() => {
          setInitialized(true)
        })
      }
      // if keycloak initialization times out in error
      setTimeout(() => {
        setInitialized(true)
      }, 5000)
    }
    if (nxConfig.PUBLIC_URL == null) throw new Error('Missing .env file')
    else initializeSSO()
  }, [])

  const navigate = useNavigate()
  const query = useQuery()

  const setLoggedInLocal = async () => {
    if (
      pathname.startsWith('/admin') &&
      (pathname.includes('login') ||
        pathname.includes('auth') ||
        pathname === '/admin' ||
        pathname === '/admin/' ||
        (query?.get('session_state') && query?.get('session_state') !== ''))
    ) {
      if (KeycloakAdminService?.isContactInfoRoleAdmin() || KeycloakAdminService?.isMonitoringAdmin()) {
        navigate('/admin/electors-list')
      } else {
        navigate('/admin/dashboard')
      }
    }

    const tokenParsed = KeycloakAdminService.getTokenParsed()
    if (tokenParsed) {
      setAdminUser({
        ...tokenParsed,
        username: tokenParsed.preferred_username,
        phone: tokenParsed.phone_number,
        phoneNumber: tokenParsed.phone_number,
        email: tokenParsed.email,
      })
    }
    const tiviLink = await AdminVoterAuthService.getTiviElectionComponentLink()
    if (tiviLink && KeycloakAdminService?.isLoggedIn() && !KeycloakAdminService?.isContactInfoRoleAdmin()) {
      setTiviLink(tiviLink)
    }
    setSavedKeycloakLanguage()
    window.addEventListener('beforeunload', beforeUnload)

    setAuthChecked(true)
  }

  const clearLocalSession = () => {
    setAuthChecked(true)
    setAdminUser(null)
    window.removeEventListener('beforeunload', beforeUnload)
    // only pages authenticated user can navigate directly, other auth pages should redirect to login
    if (pathname.startsWith('/admin') && !pathname.includes('login') && !pathname.includes('reset-password')) {
      navigate('/admin/login')
    }
  }

  const checkAuth = async () => {
    // is logged in
    if (initialized && KeycloakAdminService?.isLoggedIn()) {
      setLoggedInLocal()
    }
    if (initialized && !KeycloakAdminService?.isLoggedIn()) {
      clearLocalSession()
    }
  }

  useEffect(() => {
    checkAuth()
  }, [initialized, KeycloakAdminService?.isLoggedIn()])

  // set language saved in app
  const setSavedKeycloakLanguage = () => {
    if (KeycloakAdminService.isLoggedIn()) {
      AdminVoterService.updateUserLanguage(currentLanguage)
    }
  }
}
